
module.exports = {
    defaultPage: "/about",
    languages: ["de", "en"],
    widths: {
        sm: {
            left: 0,
            right: 0,
            main: "full"
        },
        md: {
            left: 0,
            right: 0,
            main: "full"
        },
        lg: {
            left: "4/24",
            right: "4/24",
            main: "16/24"
        },
        xl: {
            left: "5/24",
            right: "5/24",
            main: "14/24"
        }
    }
};